import React from 'react';
import Udesk from 'Udesk';
import { getInspectionTasksSourceBySource } from 'src/api/inspectionTasks/source/{source}';
import { postAiModelInsightTask, getAiModelInsightTaskList } from 'src/api/aiModelInsight/task';
import UdeskLocales from 'UdeskLocales';

const PAGE_SIZE = 20;
class AiReportComponent extends React.Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};
    privates = {
        isFront: true, // true: 列表页, false: 详情页
        reportParams: {
            taskId: undefined,
            description: '',
        },
        taskList: [],
        reportList: [],
        reportListPaging: { pageNum: 1, pageSize: PAGE_SIZE, total: 0 },
        reportListLoading: false,
        currentReport: null,
        formRef: React.createRef(),
    };

    actions = {
        generateReport() {
            postAiModelInsightTask({
                taskId: this.privates.reportParams.taskId,
                require: this.privates.reportParams.description,
            }).then(
                () => {
                    this.actions.reloadAsyncModel();
                    Udesk.ui.notify.success(/* 提交成功 */UdeskLocales['current'].components.smartToolBar.aiReport.component.submittedSuccessfully);
                    //清空表单
                    this.privates.reportParams = {
                        taskId: undefined,
                        description: '',
                    };
                    if (this.privates.formRef.current) {
                        this.privates.formRef.current.resetFields();
                    }
                    this.actions.update();
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                }
            );
        },
        onFormChange(changedValues, allValues) {
            this.privates.reportParams = {
                ...this.privates.reportParams,
                ...allValues,
            };
        },
        viewReport(report) {
            this.privates.currentReport = report;
            this.privates.isFront = false;
            this.actions.update();
        },
        backToIndex() {
            this.privates.isFront = true;
            this.privates.currentReport = null;
            this.actions.update();
        },
        downloadReport(report) {
            if (report.resultLink) {
                let url = report.resultLink;
                if (this.props.sdkOptions.props.domain) {
                    url = this.props.sdkOptions.props.domain + url;
                }
                window.open(url, '_blank');
            }
        },
        reloadReportList() {
            this.actions.reloadAsyncModel();
        },
        onReportListInView(inView) {
            if (!inView) return;
            const { reportListPaging, reportListLoading } = this.privates;
            const { pageNum, pageSize, total } = reportListPaging;
            const hasMore = pageNum * pageSize < total;
            if (!hasMore || reportListLoading) return;
            this.actions.loadMoreReports();
        },
        loadMoreReports() {
            const { reportListPaging, reportListLoading } = this.privates;
            if (reportListLoading) return;
            const nextPageNum = reportListPaging.pageNum + 1;
            this.privates.reportListLoading = true;
            this.actions.update();
            getAiModelInsightTaskList({
                params: {
                    pageNum: nextPageNum,
                    pageSize: reportListPaging.pageSize,
                },
            }).then(
                (resp) => {
                    this.privates.reportListLoading = false;
                    this.privates.reportList = [
                        ...this.privates.reportList,
                        ...(resp.data || []).map((item) => ({ ...item })),
                    ];
                    if (resp.paging) {
                        this.privates.reportListPaging = {
                            ...this.privates.reportListPaging,
                            ...resp.paging,
                        };
                    }
                    this.actions.update();
                },
                () => {
                    this.privates.reportListLoading = false;
                    this.actions.update();
                }
            );
        },
    };

    componentDidMount() {
        getInspectionTasksSourceBySource({
            segments: {
                source: 0
            }
        }).then((resp) => {
            this.privates.taskList = resp.data?.map(item => ({
                id: item.id,
                name: item.name,
            }));
            this.actions.update();
        });
    }

    parseProps({ props }) {
        return {};
    }

    asyncModel() {
        getAiModelInsightTaskList({
            params: {
                pageNum: 1,
                pageSize: PAGE_SIZE,
            },
        }).then((resp) => {
            this.privates.reportList = (resp.data || []).map((item) => ({ ...item }));
            if (resp.paging) {
                this.privates.reportListPaging = {
                    pageNum: 1,
                    pageSize: resp.paging.pageSize ?? PAGE_SIZE,
                    total: resp.paging.total ?? 0,
                };
            } else {
                this.privates.reportListPaging = {
                    pageNum: 1,
                    pageSize: PAGE_SIZE,
                    total: this.privates.reportList.length,
                };
            }
            this.actions.update();
        });
    }
}

export default AiReportComponent;
